<template>
    <div>
        <div v-loading="loadingChartData">
            <el-button @click="preMonth" type="text" size="small">上个月</el-button>
            <el-button @click="nextMonth" type="text" size="small">下个月</el-button>
            <h5 class="title">{{getTitle()}}</h5>
            <ve-histogram :data="chartData" :log="false" :settings="settings"></ve-histogram>
        </div>
    </div>
</template>
<script>
import { get } from "@/assets/common/request";
import moment from 'moment';

export default {
    name: "UseData",
    props: {
        meterId: {
            type: String,
            default: undefined
        },
        payMeterNo: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            currentDate: moment().format("YYYY-MM"),
            unit: '度',
            settings: {
            },
            loadingChartData: false,
            chartData: {
                columns: [],
                rows: []
            }
        }
    },
    methods: {
        loadData() {
            this.loadingChartData = true;
            const url = 'meter/web/snapshot/listUseData';
            const date = this.currentDate;
            get(url, {meterId: this.meterId, date: date})
            .then(data => {
                this.chartData = data.data;
                this.unit = data.data.unit;
                this.loadingChartData = false;
            })
            .finally(() => {
                this.loadingChartData = false;
            });
        },
        getTitle() {
            return `表号【${this.payMeterNo}】${this.currentDate}每日使用量（单位：${this.unit}）`;
        },
        preMonth() {
            let date = moment(this.currentDate).add(-1, 'month').format("YYYY-MM");
            this.currentDate = date;
            this.loadData();
        },
        nextMonth() {
            let date = moment(this.currentDate).add(1, 'month').format("YYYY-MM");
            this.currentDate = date;
            this.loadData();
        },
    },
    mounted() {
        if(this.meterId) {
            this.loadData();
        }
    }
}
</script>

<style scoped>
.title {
    font-weight: bold;
    font-size: large;
    text-align: center;
}
</style>